import React, { useContext, useRef, useEffect,useReducer } from 'react';
import { Parallax, Background } from 'react-parallax';
import Header from "../componentes/Header";
import Footer from '../componentes/Footer';
import Seccion from "../componentes/Seccion";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Navbar from "../componentes/Navbar";
import routes from '../componentes/util/routes';


const Plantilla = props => {

    
    return (
    <div>
        <Header></Header>
        <Seccion theme='white' epicBarDirection="right" id="business_home">
            <Row id="business-about">
                <Col md={12} lg={6}>
                        <div className="line">
                                <div>
                                <h2 className=" title mrg-bt-10 txt-uppercase line-height-title letter-spacing-3px l:-mrg-right-60 fw-black fs-60">
                                    BENEFITS <br/> 
                                    <span className="fw-light">
                                    OF <br/> 
                                    DICIO
                                    </span>
                                </h2>
                                </div>
                                <br></br>
                                <div>
                                <ul className="--check">
                                    <li>
                                    Deterministic Unique Number, Correlates and Masks
                                    </li>
                                    <li>
                                    Advanced Cryptographic Key Based on Vectorized Face
                                    </li>
                                    <li>
                                    DNA Genome Profile of Personal Data
                                    </li>
                                    <li>
                                    Advanced Video Token
                                    </li>
                                    <li>
                                    Attestation and Consent in Blockchain with Face Keys
                                    </li>
                                    <li>
                                    Wallet with Universal Points
                                    </li>
                                </ul>
                                </div>
                            </div>
                </Col>
                <Col md={12} lg={6} style={{paddingTop:"50px"}}>
                      <div>
                            <iframe src="https://www.youtube.com/embed/JxDDqQaXHRE?rel=0&amp;showinfo=0&amp;controls=0" 
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                            allowFullScreen="" 
                            frameBorder="0" 
                            proportional="rectangle, static" 
                            className="w-100 aspect-ratio-item" 
                            style={{height: "287px"}}>
                            </iframe>
                          </div>

              </Col>
            </Row>
        </Seccion>
        <Seccion theme='dark' id="business_home2">
            <Row id="business-about">
                <Col md={12} lg={6}>
                        <div className="line">
                                <div>
                                <h2 className=" title mrg-bt-10 txt-uppercase line-height-title letter-spacing-3px l:-mrg-right-60 fw-black fs-60">
                                    BENEFITS <br/> 
                                    <span className="fw-light">
                                    OF <br/> 
                                    DICIO
                                    </span>
                                </h2>
                                </div>
                                <br></br>
                                <div>
                                <ul className="--check">
                                    <li>
                                    Deterministic Unique Number, Correlates and Masks
                                    </li>
                                    <li>
                                    Advanced Cryptographic Key Based on Vectorized Face
                                    </li>
                                    <li>
                                    DNA Genome Profile of Personal Data
                                    </li>
                                    <li>
                                    Advanced Video Token
                                    </li>
                                    <li>
                                    Attestation and Consent in Blockchain with Face Keys
                                    </li>
                                    <li>
                                    Wallet with Universal Points
                                    </li>
                                </ul>
                                </div>
                            </div>
                </Col>
                <Col md={12} lg={6} style={{paddingTop:"50px"}}>
                      <div>
                            <iframe src="https://www.youtube.com/embed/JxDDqQaXHRE?rel=0&amp;showinfo=0&amp;controls=0" 
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                            allowFullScreen="" 
                            frameBorder="0" 
                            proportional="rectangle, static" 
                            className="w-100 aspect-ratio-item" 
                            style={{height: "287px"}}>
                            </iframe>
                          </div>

              </Col>
            </Row>
        </Seccion>
    </div>
    );
}
export default Plantilla;